import { useEffect } from "react"
import { usePoliciesAccepted } from "@/hooks/usePoliciesAccepted"
import { useModals } from "@/modals"

export const useCheckPolicy = () => {
  const { openModal } = useModals()
  const { isReady, termsLoaded, termsAccepted, policyLoaded, policyAccepted } =
    usePoliciesAccepted()

  useEffect(() => {
    if (isReady && termsLoaded && !termsAccepted) {
      openModal("termsOfUse")
    }
  }, [isReady, termsLoaded, termsAccepted])

  useEffect(() => {
    if (termsAccepted && policyLoaded && !policyAccepted) {
      openModal("privacyPolicy")
    }
  }, [termsAccepted, policyLoaded, policyAccepted])
}
